// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  appUrl: window.location.origin + '/',
  tusgarApi1: 'https://api.puntoinmobiliario.ivvit.net/',
  //tusgarApi1: 'http://localhost:8080/',
  imageCluster: `https://api.puntoinmobiliario.ivvit.net/assets/images/icons/m/m`,
  searchRadius: 800,
  isRealState: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
